<template>
    <div class="MyAccount">
        <div class="tips"
            :class="ostatusObj.ostatus == 4 || ostatusObj.ostatus == 5 || ostatusObj.ostatus == 6 || ostatusObj.ostatus == 7 || ostatusObj.ostatus == 15 || ostatusObj.ostatus == 17 ? 'tips-red' : ostatusObj.ostatus == 1 || ostatusObj.ostatus == 11 || ostatusObj.ostatus == 12 || ostatusObj.ostatus == 13 || ostatusObj.ostatus == 14 || ostatusObj.ostatus == 16 ? 'tips-blue' : 'tips-green'"
            v-if="ostatusObj.ostatus != 3">
            <div class="tips-left">
                <img :src="ostatusObj.ostatus == 1 || ostatusObj.ostatus == 11 || ostatusObj.ostatus == 12 || ostatusObj.ostatus == 13 || ostatusObj.ostatus == 14 || ostatusObj.ostatus == 16 ? 'https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/icon_information%402x.png' : ostatusObj.ostatus == 4 || ostatusObj.ostatus == 5 || ostatusObj.ostatus == 6 || ostatusObj.ostatus == 7 || ostatusObj.ostatus == 15 || ostatusObj.ostatus == 17 ? 'https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/icon_weitongguo%402x.png' : 'https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/icon_shenhezhong%402x.png'"
                    alt="">{{ ostatusObj.ostatusTips }}
            </div>
            <div class="tips-right">
                <div class="tips-btn" @click="learnMore"
                    v-if="ostatusObj.ostatus == 1 || ostatusObj.ostatus == 11 || ostatusObj.ostatus == 12 || ostatusObj.ostatus == 13 || ostatusObj.ostatus == 14 || ostatusObj.ostatus == 16">
                    {{
                        $t('myAccount.text148') }}</div>
                <div class="tips-btn tips-p" @click="gotoByUserStatus"
                    v-if="ostatusObj.ostatus == 1 || ostatusObj.ostatus == 11 || ostatusObj.ostatus == 12 || ostatusObj.ostatus == 13 || ostatusObj.ostatus == 14 || ostatusObj.ostatus == 16">
                    {{
                        $t('myAccount.text149') }}</div>
                <div class="tips-btn tips-btn-red" @click="gotoByUserStatus"
                    v-if="ostatusObj.ostatus == 4 || ostatusObj.ostatus == 5 || ostatusObj.ostatus == 6 || ostatusObj.ostatus == 7 || ostatusObj.ostatus == 15 || ostatusObj.ostatus == 17">
                    {{
                        $t('myAccount.text149') }}</div>
            </div>
        </div>
        <div class="tabs">
            <div class="tabs-li" :class="tipsType == 1 ? 'active-tab' : ''" @click="tipChange(1)">{{
                $t('myAccount.text150')
                }}</div>
            <div class="tabs-li" :class="tipsType == 2 ? 'active-tab' : ''" @click="tipChange(2)">{{
                $t('myAccount.text151')
                }}</div>
        </div>
        <div class="basic-infomation" v-if="tipsType == 1">
            <div class="heading">
                <img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/icon_basic_infomation%402x.png"
                    alt="">
                <div class="title">{{ $t('myAccount.text9') }}</div>
            </div>
            <ul>
                <li class="head-li">
                    <div class="label">{{ $t('myAccount.text10') }}</div>
                    <div class="value">
                        <img class="headpic" :src="userInfo.headpicUrl" alt />
                    </div>
                    <div class="operate">
                        <div class="btn" @click="ModifyHeadImgFun">{{ $t('myAccount.text11') }}</div>
                    </div>
                </li>
                <li>
                    <div class="label">{{ $t('myAccount.text12') }}</div>
                    <div class="value">
                        {{ userInfo.nickname }}
                    </div>
                    <div class="operate">
                        <div class="btn" @click="ModifyNickNameFun">{{ $t('myAccount.text11') }}</div>
                    </div>
                </li>
                <li v-if="agentConfig.phoneLoginReg">
                    <div class="label">{{ $t('myAccount.text14') }}</div>
                    <div class="value">
                        {{ userInfo.phone }}
                    </div>
                    <div class="operate">
                        <div class="btn" @click="openBindingPhoneModel"
                            v-if="userInfo.phone && email && agentConfig.phoneLoginReg && agentConfig.emailLoginReg">
                            {{ $t('myAccount.text25') }}</div>
                        <div class="btn" @click="openBindingPhoneModel" v-if="!userInfo.phone">
                            {{ $t('myAccount.text26') }}</div>
                    </div>
                </li>
                <li v-if="agentConfig.emailLoginReg">
                    <div class="label">{{ $t('myAccount.text24') }}</div>
                    <div class="value">
                        {{ email }}
                    </div>
                    <div class="operate">
                        <div class="btn" @click="openBindingEmailModel"
                            v-if="userInfo.phone && email && agentConfig.phoneLoginReg && agentConfig.emailLoginReg">
                            {{ $t('myAccount.text25') }}</div>
                        <div class="btn" @click="openBindingEmailModel" v-if="!email">
                            {{ $t('myAccount.text26') }}</div>
                    </div>
                </li>
                <li>
                    <div class="label">{{ $t('myAccount.text21') }}</div>
                    <div class="value">
                    </div>
                    <div class="operate">
                        <div class="btn" @click="openPersonalDataModel">
                            {{ needAddtlMaterial ? $t('myAccount.text22') : $t('myAccount.text23') }}</div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="basic-infomation" v-if="tipsType == 1">
            <div class="heading">
                <img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/icon_verification%402x.png"
                    alt="">
                <div class="title">{{ $t('myAccount.text152') }}</div>
            </div>
            <ul>
                <li>
                    <div class="label">{{ $t('myAccount.text152') }}</div>
                    <div class="value fs16" :class="ostatusObj.ostatus == 3 ? 'gree' : 'red'">
                        {{ ostatusObj.ostatus ? ostatusText[ostatusObj.ostatus].text : '' }} <span class="graw">{{
                            $t('myAccount.text170') }}{{
                                stepNumber >= 4 ? '3' : stepNumber }}/{{ stepNumber >= 4 ? '4' : '3' }}{{
                                $t('myAccount.text171') }}</span>
                    </div>
                    <div class="operate" v-if="ostatusObj.ostatus != 3" @click="gotoByUserStatus">
                        <div class="btn">{{ ostatusObj.ostatus ? ostatusText[ostatusObj.ostatus].btn : '' }}</div>
                    </div>
                </li>
                <li>
                    <div class="label">{{ $t('myAccount.text153') }}</div>
                    <div class="schedule-value">
                        <div class="schedule">
                            <div class="step" :class="stepNumber >= 1 ? 'step-active' : ''">
                                <div class="number">1</div>
                                <p>{{ $t('myAccount.text166') }}</p>
                            </div>
                            <div class="step" :class="stepNumber >= 2 ? 'step-active' : ''">
                                <div class="number">2</div>
                                <p>{{ $t('myAccount.text167') }}</p>
                            </div>
                            <div class="step" :class="stepNumber >= 3 ? 'step-active' : ''">
                                <div class="number">3</div>
                                <p>{{ $t('AccountAssets.text38') }}</p>
                            </div>
                            <div class="step" v-if="stepNumber == 4">
                                <div class="number">4</div>
                                <p>{{ $t('myAccount.text56') }}</p>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="bank-center" v-if="tipsType == 1">
            <div class="bank-card heading">
                <img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/icon_bank_card.png" alt="">
                <div class="title">{{ $t('myAccount.text33') }}</div>
                <div class="btn" @click="openAddBankCard">{{ $t('myAccount.text34') }}</div>
            </div>
            <div class="bank-card-list">
                <div class="bank-card-list-item"
                    :class="item.currentType.indexOf(',') != -1 ? '' : item.currentType.indexOf('MYR') != -1 ? 'maybank' : item.currentType.indexOf('USD') != -1 ? 'jpmorgran' : item.currentType.indexOf('THB') != -1 ? 'bangkok' : item.currentType.indexOf('CNY') != -1 ? 'cny' : item.currentType.indexOf('IDR') != -1 ? 'idr' : item.currentType.indexOf('VND') != -1 ? 'vnd' : ''"
                    v-for="item in bankCardInfo">
                    <div class="card-head" :class="item.currentType.indexOf(',') != -1 ? 'oneCurr' : 'oreCurr'">
                        <div class="icon_box">
                            <img v-if="item.currentType.indexOf('MYR') != -1"
                                src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/accountInformation/icon_myr%402x.png"
                                alt="">
                            <img v-if="item.currentType.indexOf('USD') != -1"
                                src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/accountInformation/icon_usd%402x.png"
                                alt="">
                            <img v-if="item.currentType.indexOf('THB') != -1"
                                src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/accountInformation/icon_thb%402x.png"
                                alt="">
                            <img v-if="item.currentType.indexOf('CNY') != -1"
                                src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/accountInformation/icon_cny%402x.png"
                                alt="">
                            <img v-if="item.currentType.indexOf('IDR') != -1"
                                src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/accountInformation/icon_idr%402x.png"
                                alt="">
                            <img v-if="item.currentType.indexOf('VND') != -1"
                                src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/accountInformation/icon_vnd%402x.png"
                                alt="">
                        </div>
                        <div class="card-name">
                            {{ item.bankTypeName }}
                        </div>
                        <div class="unbind cursor" @click="Unbind(item)">
                            {{ $t('myAccount.text25') }}
                        </div>
                    </div>
                    <div class="bank-account">
                        ···· ···· ···· {{ item.bankAccount.substring(item.bankAccount.length - 4) }}
                    </div>
                </div>
            </div>
        </div>
        <div class="withdrawal-address" v-if="tipsType == 1">
            <div class="heading">
                <img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/icon_address.png" alt="">
                <div class="title">{{ $t('myAccount.text35') }}</div>
                <div class="btn" @click="openAddWithdrawalAddress">{{ $t('myAccount.text34') }}</div>
            </div>
            <div class="withdrawal-address-list">
                <div class="withdrawal-address-list-item"
                    :class="item.currency == 'BTC' ? 'btc-class' : item.currency == 'ETH' ? 'eth-class' : ''"
                    v-for="item in withDrawInfo">
                    <div class="withdrawal-head">
                        <img :src="item.icon" alt="">
                        <div class="remark">{{ item.remark }}</div>
                        <div class="delete cursor" @click="deleteWalletAddress(item)">
                            {{ $t('myAccount.text36') }}
                        </div>
                    </div>
                    <div class="address">
                        {{ item.address }}
                    </div>
                </div>
            </div>
        </div>
        <div class="security-center security-center-2" v-if="tipsType == 2">
            <div class="security-center-half">
                <div class="heading">
                    <img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/icon_web%402x.png" alt="">
                    <div class="title">{{ $t('myAccount.text154') }}</div>
                    <div class="add-acc" @click="addWeb">{{ $t('myAccount.text156') }}</div>
                </div>
                <ul v-if="webList.length > 0">
                    <li v-for="item of webList" :key="item.id">
                        <div class="id-name">{{ item.id }}({{ item.name }})</div>
                        <div class="amount">${{ item.amount }}</div>
                    </li>
                </ul>
            </div>
            <div class="security-center-half">
                <div class="heading">
                    <img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/icon_mt4%402x.png" alt="">
                    <div class="title">{{ $t('myAccount.text155') }}</div>
                    <div class="add-acc" @click="addMT4">{{ $t('myAccount.text156') }}</div>
                </div>
                <ul v-if="mt4List.length > 0">
                    <li v-for="item of mt4List" :key="item.id">
                        <div class="id-name">{{ item.id }}</div>
                        <div class="amount">${{ item.amount }}</div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="security-center" v-if="tipsType == 2">
            <div class="heading">
                <img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/icon_verification.png" alt="">
                <div class="title">{{ $t('myAccount.text27') }}</div>
            </div>
            <ul>
                <li>
                    <div class="label">{{ $t('myAccount.text28') }}</div>
                    <div class="value">
                    </div>
                    <div class="operate">
                        <div class="btn" @click="changeOrSetLoginPassword">
                            {{ ostatusObj.modifyPwd ? $t('myAccount.text11') : $t('myAccount.text29') }}</div>
                    </div>
                </li>
                <li>
                    <div class="label">{{ $t('myAccount.text32') }}</div>
                    <div class="value">
                    </div>
                    <div class="operate">
                        <div class="btn" @click="openSetTradingPassword">
                            {{ ostatusObj.hasTradePwd ? $t('myAccount.text11') : $t('myAccount.text29') }}</div>
                    </div>
                </li>
                <li v-if="ostatusObj.hasMT4Live">
                    <div class="label">{{ $t('myAccount.text143') }}</div>
                    <div class="value">
                    </div>
                    <div class="operate">
                        <div class="btn" @click="openResetMT4LivePassword">{{ $t('myAccount.text31') }}</div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="security-center" v-if="tipsType == 2 && mt4List.length > 0">
            <div class="heading">
                <img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/icon_lever%402x.png" alt="">
                <div class="title">{{ $t('myAccount.text172') }}</div>
            </div>
            <ul>
                <li>
                    <div class="label">{{ $t('myAccount.text173') }}</div>
                    <div class="value">
                    </div>
                    <div class="operate">
                        <div class="btn" @click="changeLever">
                            {{ $t('myAccount.text174') }}</div>
                    </div>
                </li>
            </ul>
        </div>
        <el-dialog v-model="dialogVisible2" :title="$t('myAccount.text173')" width="500" @closed="closed">
            <div class="lever-line">
                <div class="lever-line-label">{{ $t('AccountAssets.text110') }}</div>
                <div class="lever-line-value">
                    <el-select v-model="lever" style="width: 320px">
                        <el-option v-for="item in leverMt4List" :key="item.id" :label="item.id" :value="item.id" />
                    </el-select>
                </div>

            </div>
            <div class="lever-line">
                <div class="lever-line-label">{{ $t('myAccount.text175') }}</div>
                <div class="lever-line-value">
                    <el-select v-model="leveragesItem" :placeholder="$t('myAccount.text126')" style="width: 320px">
                        <el-option v-for="item in leverages" :key="item.value" :label="item.text" :value="item.value" />
                    </el-select>
                </div>
            </div>
            <div class="lever-text">
                {{ leveragesTitle }}
            </div>
            <p class="lever-pro">
                {{ leveragesTips }}
            </p>
            <el-button :disabled="!leverDisabled" class="lever-btn" type="primary" @click="SetMt4LeverageConfirm">{{
                $t('AccountAssets.text81')
                }}</el-button>
        </el-dialog>
        <el-dialog v-model="dialogVisible" center :title="$t('myAccount.text165')" width="400">
            <div class="step-box">
                <div class="schedule-2 ">
                    <div class="step-2" :class="stepNumber >= 1 ? 'step-active' : ''">
                        <div class="number">1</div>
                        <p>{{ $t('myAccount.text166') }}</p>
                    </div>
                    <div class="step-2" :class="stepNumber >= 2 ? 'step-active' : ''">
                        <div class="number">2</div>
                        <p>{{ $t('myAccount.text167') }}</p>
                    </div>
                    <div class="step-2" :class="stepNumber >= 3 ? 'step-active' : ''">
                        <div class="number">3</div>
                        <p>{{ $t('AccountAssets.text38') }}</p>
                    </div>
                    <div class="step-2" v-if="stepNumber == 4">
                        <div class="number">4</div>
                        <p>{{ $t('myAccount.text56') }}</p>
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="dialogVisible = false">{{ $t('myAccount.text159') }}</el-button>
                    <el-button type="primary" @click="gotoByUserStatus">
                        {{ $t('myAccount.text149') }}
                    </el-button>
                </div>
            </template>
        </el-dialog>
        <el-dialog v-model="dialogVisible3" center width="400" :show-close="false">
            <img class="icon_success"
                src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/icon_success%402x.png" alt="">
            <p class="icon_success_pro">{{ $t('myAccount.text183') }}</p>
            <div class="haode" @click="dialogVisible3 = false">{{ $t('myAccount.text164') }}</div>
            <div style="clear: both;"></div>
        </el-dialog>
        <ModifyPersonalData />
        <BindEmail />
        <BindPhone />
        <ModifyHeadImg />
        <ModifyNickName />
        <SetLoginPassword />
        <ChangeLoginPassword />
        <ResetMT4LivePassword :mt4List="mt4List" />
        <SetTradingPassword />
        <ChangeTradingPassword />
        <AddBankCard />
        <AddWithdrawalAddress />
    </div>
</template>

<script>
import { useStore } from 'vuex';
import { useI18n } from "vue-i18n";
import ModifyPersonalData from '@/components/AccountInformation/ModifyPersonalData'
import BindEmail from '@/components/MyAccount/BindEmail'
import BindPhone from '@/components/MyAccount/BindPhone'
import ModifyHeadImg from '@/components/MyAccount/ModifyHeadImg'
import ModifyNickName from '@/components/MyAccount/ModifyNickName'
import SetLoginPassword from '@/components/MyAccount/SetLoginPassword'
import ChangeLoginPassword from '@/components/MyAccount/ChangeLoginPassword'
import ResetMT4LivePassword from '@/components/MyAccount/ResetMT4LivePassword'
import AddBankCard from '@/components/AddBankCardModel'
import AddWithdrawalAddress from '@/components/MyAccount/AddWithdrawalAddress'
import apiService from '@/api/request';
import { computed, inject, ref, onBeforeUnmount, onBeforeMount } from 'vue';
import { ElMessageBox, ElMessage } from 'element-plus'
import { xzLocal } from "@/until/common";
import { useRouter, useRoute } from "vue-router";


export default {
    name: 'MyAccount',
    props: {

    },
    components: {
        ModifyPersonalData,
        BindEmail,
        BindPhone,
        ModifyHeadImg,
        ModifyNickName,
        SetLoginPassword,
        ChangeLoginPassword,
        AddBankCard,
        AddWithdrawalAddress,
        ResetMT4LivePassword
    },
    setup() {

        const store = useStore();
        const { t } = useI18n()
        const emitt = inject('emitt');
        const router = useRouter();
        const route = useRoute();


        const withDrawInfo = ref([])

        store.dispatch('getUserInfo');
        store.dispatch('getUserStatus');
        store.dispatch('getWalletBank');

        const tipsType = ref(1);
        const webList = ref([]);//web账号列表
        const mt4List = ref([]);//mt4账号列表
        const dialogVisible = ref(false);//了解详情弹窗
        const dialogVisible2 = ref(false);//Mt4杠杆调整
        const dialogVisible3 = ref(false);
        const lever = ref('');
        const leverMt4List = ref([]);

        const agentConfig = computed({ get: () => store.getters.getAgentConfig });

        function tipChange(e) {
            tipsType.value = e;
        }

        function changeLever() {
            dialogVisible2.value = true;
        }

        onBeforeMount(() => {
            console.log("route.params.needVerification", route.params)
            if (route.params.needVerification) {
                gotoByUserStatus();
            }
            if (store.state.user.userInfo) {
                // setInterval(() => {
                //     console.log("store.state.user.userInfo",store.state.user)

                // },1000)
            }
        })
        //用户信息
        const userInfo = computed({
            get: () => {
                return store.state.user.userInfo;
            },
        });


        //用户认证状态
        const ostatusObj = computed({
            get: () => store.state.user.userStatus,
        });
        GetAllAccountList();

        function GetAllAccountList() {
            apiService.GetAllAccountList().then(res => {
                console.log("GetAllAccountList", res)
                if (res.status == 1) {
                    webList.value = res.data.webList;
                    mt4List.value = res.data.mt4List;
                    leverMt4List.value = [...[{ id: t('myAccount.text176') }], ...res.data.mt4List];
                    lever.value = res.data.mt4List[0]?.id
                }
            })
        }

        //用户认证状态
        const stepNumber = computed({
            get: () => {
                let step = 0;
                console.log("store.state.user.userStatus", store.state.user.userStatus)
                switch (store.state.user.userStatus.ostatus) {
                    case 0:
                    case 1://未认证
                    case 6://审核未通过-存在于黑名单中
                    case 4://身份证错误
                        step = 0;
                        break;
                    case 11://已上传信息，未提交证件
                    case 16://重填证件信息
                    case 17://审核未通过-身份证翻译失败
                        step = 1;
                        break;
                    case 5:
                    case 12:
                        step = 2;
                        break;
                    case 2:
                    case 3:
                        step = 3;
                        break;
                    case 7://审核未通过-地址认证失败
                    case 13://已提交证件，未提交地址证件
                    case 14://已提交证件，未提交手持身份证件
                    case 15://审核未通过，手持身份证认证失败
                        step = 4
                        break;
                }



                return step
            }
        });
        //邮箱
        const email = computed({
            get: () => {
                return store.state.user.userInfo.email;
            },
        });

        // 是否需要完善个人资料
        const needAddtlMaterial = computed({
            get: () => store.state.user.userStatus.needAddtlMaterial,
        });

        // 获取用户当前状态
        if (!localStorage.JudgmentAddressSupplement) {
            userStatus();
        }

        //获取银行卡
        const bankCardInfo = computed(() => store.getters.walletBank);

        function userStatus() {
            apiService.UserStatus().then((res) => {
                console.log('PersonalData', res);
                if (res.status === 1) {
                    JudgmentAddressSupplement(res.data.ostatus, res.data.addressStatus)
                }
            });
        }

        /**
        * 修改MT4密码
        */
        function openResetMT4LivePassword() {
            emitt.$pub('openResetMT4LivePassword');
        }

        //获取提币地址
        emitt.$sub('getWalletAddress', (val) => {
            getWalletAddress();
        });
        onBeforeUnmount(() => {
            emitt.$unsub("getWalletAddress");
        });
        getWalletAddress();
        function getWalletAddress() {
            withDrawInfo.length = 0;
            apiService.WalletAddress().then((res) => {
                if (res.status === 1) {
                    withDrawInfo.value = res.data.listWalletAddress;
                }
            });
        }


        /**
        * 判断地址是否补充-开始
        */
        function JudgmentAddressSupplement(ostatus, addressStatus) {
            if (ostatus == 3 && addressStatus !== 3 && addressStatus !== 0) {
                if (addressStatus == 0 || addressStatus == 1) {
                    ElMessageBox.confirm(t('myAccount.text55'), {
                        confirmButtonText: t('myAccount.text56'),
                        cancelButtonText: t('trade.text72'),
                    })
                        .then(() => {
                            localStorage.JudgmentAddressSupplement = true;
                            router.push({
                                name: "addressFailed",
                                query: {
                                    erroeType: 1
                                }
                            })
                        })
                        .catch(() => {
                            localStorage.JudgmentAddressSupplement = true;
                        })
                } else if (addressStatus == 4) {
                    ElMessageBox.confirm(t('myAccount.text57'), {
                        confirmButtonText: t('myAccount.text58'),
                        cancelButtonText: t('trade.text72'),
                    })
                        .then(() => {
                            localStorage.JudgmentAddressSupplement = true;
                            router.push({
                                name: "addressFailed",
                                query: {
                                    erroeType: 2
                                }
                            })
                        })
                        .catch(() => {
                            localStorage.JudgmentAddressSupplement = true;
                        })
                }
            }
        }

        // 当前认证状态
        const ostatusText = {
            1: {
                text: t('myAccount.text37'),
                btn: t('myAccount.text22'),
            },
            2: {
                text: t('myAccount.text18'),
                btn: t('myAccount.text132'),
            },
            3: {
                text: t('myAccount.text38'),
                btn: '',
            },
            4: {
                text: t('myAccount.text39'),
                btn: t('myAccount.text40'),
            },
            6: {
                text: t('myAccount.text39'),
                btn: t('myAccount.text40'),
            },
            17: {
                text: t('myAccount.text39'),
                btn: t('myAccount.text40'),
            },
            5: {
                text: t('myAccount.text41'),
                btn: t('myAccount.text22'),
            },
            7: {
                text: t('myAccount.text42'),
                btn: t('myAccount.text22'),
            },
            11: {
                text: t('myAccount.text43'),
                btn: t('myAccount.text40'),
            },
            12: {
                text: t('myAccount.text44'),
                btn: t('myAccount.text22'),
            },
            13: {
                text: t('myAccount.text44'),
                btn: t('myAccount.text22'),
            },
            14: {
                text: t('myAccount.text45'),
                btn: t('myAccount.text40'),
            },
            16: {
                text: t('myAccount.text45'),
                btn: t('myAccount.text40'),
            },
            15: {
                text: t('myAccount.text46'),
                btn: t('myAccount.text22'),
            },
        };


        //弹出个人信息框，编辑或者填写-开始
        function openPersonalDataModel() {
            emitt.$pub('openPersonalDataModel');
        }

        // 添加银行卡
        function openAddBankCard() {
            if (userInfo.value.ostatus != 3) {
                gotoByUserStatus();
                return
            }
            emitt.$pub('openAddBankCard');
        }

        // 解绑银行卡-开始
        function Unbind(item) {
            ElMessageBox.confirm(lang.value == 'cn' ? `解除绑定您尾号${item.bankAccount.substring(item.bankAccount.length - 4)}的${item.bankTypeName}卡吗？` : `Unbind your ${item.bankTypeName} card ending in ${item.bankAccount.substring(item.bankAccount.length - 4)}?`, {
                confirmButtonText: t('myAccount.text25'),
                cancelButtonText: t('trade.text72'),
            })
                .then(() => {
                    let params = {
                        walletbankid: item.walletbankId
                    }
                    apiService.Unbindbank(params).then((res) => {
                        if (res.status == 1) {
                            ElMessage({
                                message: t('myAccount.text52'),
                                type: 'success'
                            });
                            store.dispatch('getWalletBank');
                        }
                    });
                })
                .catch(() => {

                })
        }


        //打开修改头像弹框-开始
        function ModifyHeadImgFun() {
            emitt.$pub('openModifyHeadImgModel');
        }

        //打开修改昵称弹框-开始
        function ModifyNickNameFun() {
            emitt.$pub('openModifyNickNameModel');
        }

        //获取用户当前状态-开始
        function gotoByUserStatus() {
            let ostatus = xzLocal.get('userStatus') ? xzLocal.get('userStatus').ostatus : 1
            let addressStatus = xzLocal.get('userStatus') ? xzLocal.get('userStatus').addressStatus : 1;
            console.log("userInfouserInfouserInfo", ostatus)
            switch (ostatus) {
                /** 展示第一步页面 */
                case 0:
                case 1://未认证
                case 6://审核未通过-存在于黑名单中
                case 4://身份证错误
                    router.push({
                        name: "certification",
                        query: {
                            step: 1
                        }
                    })
                    break;
                /** 展示证件收集页面-第二步*/
                case 11://已上传信息，未提交证件
                case 16://重填证件信息
                case 17://审核未通过-身份证翻译失败
                    router.push({
                        name: "certification",
                        query: {
                            step: 2
                        }
                    })
                    break;
                case 7://审核未通过-地址认证失败
                case 13://已提交证件，未提交地址证件
                    router.push("addressFailed");
                    break;
                case 2://等待审核
                    router.push({
                        name: "certification",
                        query: {
                            step: 4
                        }
                    })
                    break;
                /** 展示已认证页面-第三步*/
                case 3://已认证
                    if (addressStatus)
                        break;

                case 5://签名错误
                    router.push({
                        name: "certification",
                        query: {
                            step: 3
                        }
                    })
                    break;
                case 12://已提交证件，未提交签名
                    router.push({
                        name: "certification",
                        query: {
                            step: 3
                        }
                    })
                    break;
                /** 展示手持身份证页面*/
                case 14://已提交证件，未提交手持身份证件
                case 15://审核未通过，手持身份证认证失败
                    router.push("selfieHolding");
                    break;
            }
        }



        //弹出绑定邮箱弹框/解绑邮箱-开始
        function openBindingEmailModel() {
            if (email.value) {
                ElMessageBox.confirm(`${email.value}?`, t('myAccount.text47'), {
                    confirmButtonText: t('trade.text73'),
                    cancelButtonText: t('trade.text72'),
                })
                    .then(() => {
                        apiService.UnbindEmail().then((res) => {
                            if (res.status == 1) {
                                ElMessage({
                                    message: t('myAccount.text48'),
                                    type: 'success'
                                });
                                store.dispatch('getUserInfo');
                            }
                        });
                    })
                    .catch(() => {

                    })
            } else {
                emitt.$pub('openBindingEmailModel', {
                    phone: userInfo.value.phone,
                    mobileAreaCode: userInfo.value.mobileAreaCode
                });
            }
        }
        //弹出绑定手机号弹框/解绑手机号-开始
        function openBindingPhoneModel() {
            if (userInfo.value.phone) {
                ElMessageBox.confirm(`${userInfo.value.phone}`, t('myAccount.text47_1') + '?', {
                    confirmButtonText: t('trade.text73'),
                    cancelButtonText: t('trade.text72'),
                })
                    .then(() => {
                        apiService.UnbindPhone().then((res) => {
                            if (res.status == 1) {
                                ElMessage({
                                    message: t('myAccount.text48_1'),
                                    type: 'success'
                                });
                                store.dispatch('getUserInfo');
                            }
                        });
                    })
                    .catch(() => {

                    })
            } else {
                emitt.$pub('openBindingPhoneModel', {
                    email: email.value,
                    mobileAreaCode: userInfo.value.mobileAreaCode
                });
            }
        }


        //添加出金地址-开始
        function openAddWithdrawalAddress() {
            if (userInfo.value.ostatus != 3) {
                gotoByUserStatus();
                return
            }
            emitt.$pub('openAddWithdrawalAddress');
        }


        //删除出金地址-开始
        function deleteWalletAddress(item) {
            ElMessageBox.confirm(t('myAccount.text53'), {
                confirmButtonText: t('myAccount.text36'),
                cancelButtonText: t('trade.text72'),
            })
                .then(() => {
                    const params = {
                        id: item.id
                    }
                    apiService.WalletAddress(params, 'delete').then((res) => {
                        if (res.status === 1) {
                            getWalletAddress();
                            ElMessage({
                                message: t('myAccount.text54'),
                                type: 'success'
                            });
                        } else {
                            ElMessage({
                                message: res.message,
                                type: 'error',
                            });
                        }
                    });
                })
                .catch(() => {

                })
        }

        //修改或设置登录密码-开始
        function changeOrSetLoginPassword() {
            if (ostatusObj.value.modifyPwd) {
                emitt.$pub('openChangeLoginPassword', { title: t('myAccount.text11') });
            } else {
                emitt.$pub('openSetLoginPassword', { title: t('myAccount.text29') });
            }
        }


        //设置或修改交易密码-开始
        function openSetTradingPassword() {
            if (ostatusObj.value.hasTradePwd) {
                emitt.$pub('openChangeTradingPassword');
            } else {
                emitt.$pub('openSetTradingPassword');
            }
        }

        //添加web账号
        function addWeb() {
            if (webList.value.length >= 5) {
                ElMessageBox.alert(
                    `<div class="my-message-box__message"><img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/icon_error%402x.png" />
                                <p>${t('myAccount.text161')}</p>
                            </div>`,
                    '',
                    {
                        center: true,
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: t('myAccount.text160'),
                        callback: (action) => {
                            console.log(action)
                        },
                    }
                )
                return
            }
            ElMessageBox.confirm(t('myAccount.text157'), '', {
                confirmButtonText: t('myAccount.text158'),
                cancelButtonText: t('myAccount.text159'),
            }).then(() => {
                apiService.AddFundAccount().then(res => {
                    console.log("AddFundAccount", res)
                    if (res.status == 1) {
                        ElMessageBox.alert(
                            `<div class="my-message-box__message"><img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/icon_success%402x.png" />
                                <p>${t('myAccount.text156')}</p>
                                <p>${res.data.fundAccountId}(${res.data.fundAccountName})<p/>
                            </div>`,
                            '',
                            {
                                center: true,
                                dangerouslyUseHTMLString: true,
                                confirmButtonText: t('myAccount.text160'),
                                callback: (action) => {
                                    console.log(action)
                                },
                            }
                        )
                        GetAllAccountList();
                    } else {
                        ElMessageBox.alert(
                            `<div class="my-message-box__message"><img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/icon_error%402x.png" />
                                <p>${res.message}</p>
                            </div>`,
                            '',
                            {
                                center: true,
                                dangerouslyUseHTMLString: true,
                                confirmButtonText: t('myAccount.text160'),
                                callback: (action) => {
                                    console.log(action)
                                },
                            }
                        )
                    }
                })
            })
                .catch(() => {
                    console.log("catch");
                })
        }

        //添加MT4账号
        function addMT4() {
            if (ostatusObj.value.ostatus != 3) {
                ElMessage.info(t('AccountAssets.text96'));
                return
            };
            if (mt4List.value.length >= 5) {
                ElMessageBox.alert(
                    `<div class="my-message-box__message"><img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/icon_error%402x.png" />
                                <p>${t('myAccount.text161')}</p>
                            </div>`,
                    '',
                    {
                        center: true,
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: t('myAccount.text160'),
                        callback: (action) => {
                            console.log(action)
                        },
                    }
                )
                return
            }
            ElMessageBox.confirm(t('myAccount.text157'), '', {
                confirmButtonText: t('myAccount.text158'),
                cancelButtonText: t('myAccount.text159'),

            }).then(() => {
                apiService.AddMT4Account().then(res => {
                    if (res.status == 1) {
                        ElMessageBox.alert(
                            res.message,
                            '',
                            {
                                confirmButtonText: t('myAccount.text164'),
                                callback: (action) => {
                                    GetAllAccountList();
                                },
                            }
                        )
                    } else {
                        ElMessageBox.alert(
                            `<div class="my-message-box__message"><img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/icon_error%402x.png" />
                                <p>${t('myAccount.text163')}</p>
                            </div>`,
                            '',
                            {
                                center: true,
                                dangerouslyUseHTMLString: true,
                                confirmButtonText: t('myAccount.text160'),
                                callback: (action) => {
                                    console.log(action)
                                },
                            }
                        )
                    }
                })
            })
                .catch(() => {
                    console.log("catch");
                })
        }

        //了解详情
        function learnMore() {
            dialogVisible.value = true;
        }

        const leverages = ref([])
        const leveragesTips = ref('')
        const leveragesTitle = ref('')
        const leveragesItem = ref('')

        const leverDisabled = computed(() => {
            return leverages.value != "" &&
                leveragesItem.value != ""
        })
        GetLeverageList();
        function GetLeverageList() {
            apiService.GetLeverageList().then((res) => {
                leverages.value = res.data.leverages;
                leveragesTitle.value = res.data.title;
                leveragesTips.value = res.data.tips;
            })
        }

        function SetMt4LeverageConfirm() {
            ElMessageBox.confirm(t('myAccount.text177') + leveragesItem.value + t('myAccount.text178'))
                .then(() => {
                    SetMt4Leverage();
                })
                .catch(() => {
                    // catch error
                })
        }

        function SetMt4Leverage() {
            const params = {
                mt4loginId: lever.value == t('myAccount.text176') ? '0' : lever.value,
                leverage: leveragesItem.value,
                isAll: lever.value == t('myAccount.text176') ? '1' : '0'
            }
            apiService.SetMt4Leverage(params).then(res => {
                console.log(res)
                if (res.status == 1) {
                    dialogVisible2.value = false
                    dialogVisible3.value = true
                }
            })
        }

        function closed() {
            leveragesItem.value = '';
        }
        return {
            leveragesTitle,
            leveragesTips,
            closed,
            SetMt4LeverageConfirm,
            leverMt4List,
            SetMt4Leverage,
            leverDisabled,
            leveragesItem,
            leverages,
            learnMore,
            openBindingPhoneModel,
            userInfo,
            ostatusObj,
            ostatusText,
            openPersonalDataModel,
            email,
            needAddtlMaterial,
            bankCardInfo,
            withDrawInfo,
            openAddBankCard,
            Unbind,
            ModifyHeadImgFun,
            ModifyNickNameFun,
            gotoByUserStatus,
            openBindingEmailModel,
            openAddWithdrawalAddress,
            deleteWalletAddress,
            changeOrSetLoginPassword,
            openSetTradingPassword,
            stepNumber,
            openResetMT4LivePassword,
            tipsType,
            tipChange,
            addWeb,
            webList,
            mt4List,
            addMT4,
            dialogVisible,
            dialogVisible2,
            changeLever,
            lever,
            dialogVisible3,
            agentConfig
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.MyAccount {
    .tips {
        height: 56px;
        line-height: 56px;
        font-size: 14px;
        color: #666D7F;
        padding: 0 32px;
        display: flex;
        justify-content: space-between;

        .tips-left {
            display: flex;
            justify-content: left;
            align-items: center;
        }

        img {
            width: 16px;
            height: 16px;
            margin-right: 8px;
        }

        .tips-right {
            display: flex;
            justify-content: right;
            align-items: center;
        }

        .tips-btn {
            width: 80px;
            height: 40px;
            line-height: 40px;
            border: 1px solid #51B4F1;
            color: #51B4F1;
            text-align: center;
            border-radius: 4px;
            background-color: white;
            cursor: pointer;
        }

        .tips-p {
            background: #51B4F1;
            color: white;
            margin-left: 20px;
            border: none;
        }

        .tips-btn-red {
            width: 80px;
            height: 40px;
            line-height: 40px;
            color: white;
            text-align: center;
            border-radius: 4px;
            background-color: #EF383C;
            cursor: pointer;
            border: none;
        }
    }

    .tips-red {
        background-color: rgba(239, 56, 60, 0.2);
    }

    .tips-blue {
        background: rgba(81, 180, 241, 0.2);
    }

    .tips-green {
        background-color: #CFE9E3;
    }

    .tabs {
        display: flex;
        justify-content: space-between;
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #F2F4FB;

        .tabs-li {
            width: 50%;
            text-align: center;
            cursor: pointer;
        }

        .active-tab {
            position: relative;
            color: #51B4F1;
            font-weight: 500;

            &::after {
                content: "";
                display: block;
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                height: 2px;
                width: 134px;
                background: #51B4F1;
            }
        }
    }

    .basic-infomation {
        .heading {
            padding: 12px 30px;
            font-size: 18px;
            display: flex;
            justify-content: left;
            align-items: center;
            border-bottom: 1px solid @border-color-base;

            /*no*/
            img {
                display: block;
                width: 20px;
                height: 20px;
                margin-top: 2px;
                margin-right: 10px;
            }

            .title {
                font-weight: 500;
                width: 634px;
                text-align: left;
                font-size: 18px;
            }
        }

        ul {
            padding-left: 60px;
            text-align: left;
            border-bottom: 1px solid @border-color-base;

            li {
                min-height: 48px;
                display: flex;
                justify-content: left;
                border-bottom: 1px solid @border-color-base;
                align-items: center;

                .label {
                    width: 260px;
                    font-size: 14px;
                }

                .value {
                    width: 530px;
                    font-size: 14px;
                }

                .fs16 {
                    font-size: 16px;
                }

                .graw {
                    color: #666D7F;
                    font-size: 14px;
                }

                .gree {
                    color: @green;
                }

                .red {
                    color: @red;
                }

                &:last-child {
                    border: none;
                }

                .headpic {
                    display: block;
                    width: 48px;
                    height: 48px;
                    border-radius: 50%;
                }
            }

            .head-li {
                height: 72px;
            }
        }
    }

    .bank-center {
        .heading {
            padding: 12px 30px;
            font-size: 18px;
            display: flex;
            justify-content: left;
            align-items: center;
            border-bottom: 1px solid @border-color-base;

            /*no*/
            img {
                display: block;
                width: 20px;
                height: 20px;
                margin-top: 3px;
                margin-right: 10px;
            }

            .title {
                font-weight: 500;
                width: 790px;
                text-align: left;
                font-size: 18px;
                line-height: 28px;
            }
        }

        .bank-card-list {
            display: flex;
            justify-content: left;
            flex-wrap: wrap;
            padding-left: 62px;
            padding-right: 140px;
            padding-top: 4px;
            padding-bottom: 20px;
            border-bottom: 1px solid @border-color-base;

            /*no*/
            .bank-card-list-item {
                background: linear-gradient(315deg, #A336D0 0%, #D248ED 100%);
                width: 250px;
                margin-right: 16px;
                border-radius: 6px;
                /*no*/
                margin-top: 16px;
                padding: 10px;

                &:nth-child(3n) {
                    margin-right: 0;
                }

                .card-head {
                    overflow: hidden;

                    .icon_box {
                        float: left;
                        margin-right: 8px;

                        img {
                            width: 28px;
                        }
                    }

                    .card-name {
                        float: left;
                        font-size: 14px;
                        line-height: 28px;
                        color: @white;
                        width: 120px;
                        text-align: left;
                    }

                    .unbind {
                        padding: 2px 4px;
                        line-height: 18px;
                        font-size: 12px;
                        float: right;
                        margin-top: 3px;
                        color: @white;
                        border: 1px solid @white;
                        /*no*/
                    }
                }

                .oneCurr {
                    .icon_box {
                        img {
                            width: 20px;
                        }
                    }

                    .card-name {
                        line-height: 20px;
                        width: 80px;
                    }
                }

                .bank-account {
                    font-size: 14px;
                    color: @white;
                    margin-top: 10px;
                }

            }

            .maybank {
                background: linear-gradient(135deg, #FA9C3C 0%, #ED8526 100%);
            }

            .jpmorgran {
                background: linear-gradient(315deg, #129A9E 0%, #07BDC1 100%);
            }

            .bangkok {
                background: linear-gradient(315deg, #2E62D0 0%, #0087E7 100%);
            }

            .cny {
                background: linear-gradient(135deg, #FF7531 0%, #EC5A19 100%);
            }

            .idr {
                background: linear-gradient(135deg, #F22E8A 0%, #CD214E 100%);
            }

            .vnd {
                background: linear-gradient(135deg, #FF4040 0%, #E72424 100%);
            }
        }
    }

    .withdrawal-address {
        border-bottom: 1px solid @border-color-base;

        .heading {
            padding: 12px 30px;
            font-size: 18px;
            display: flex;
            justify-content: left;
            border-bottom: 1px solid @border-color-base;

            /*no*/
            img {
                display: block;
                width: 20px;
                height: 20px;
                margin-top: 3px;
                margin-right: 10px;
            }

            .title {
                font-weight: 500;
                width: 790px;
                text-align: left;
                font-size: 18px;
                line-height: 28px;
            }
        }

        .withdrawal-address-list {
            display: flex;
            justify-content: left;
            flex-wrap: wrap;
            padding-left: 62px;
            padding-top: 20px;

            .withdrawal-address-list-item {
                background: #1BA27A;
                width: 250px;
                height: 100px;
                border-radius: 6px;
                padding-left: 10px;
                padding-top: 14px;
                margin-right: 16px;
                padding-right: 10px;
                margin-bottom: 20px;

                &:nth-child(3n) {
                    margin-right: 0;
                }

                .withdrawal-head {
                    overflow: hidden;

                    img {
                        display: block;
                        width: 28px;
                        height: 28px;
                        float: left;
                    }

                    .remark {
                        float: left;
                        font-size: 14px;
                        margin-left: 8px;
                        color: @white;
                    }

                    .delete {
                        width: 48px;
                        height: 18px;
                        line-height: 18px;
                        font-size: 12px;
                        float: right;
                        margin-top: 3px;
                        color: @white;
                        border: 1px solid @white;
                        text-align: center;
                        /*no*/
                    }
                }

                .address {
                    color: @white;
                    text-align: left;
                    margin-top: 4px;
                    padding-left: 36px;
                    word-break: break-all;
                    display: -webkit-box; //将对象作为弹性伸缩盒子模型显示。
                    -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
                    -webkit-line-clamp: 2; //限制行数
                    overflow: hidden; //超出部分隐藏
                    text-overflow: ellipsis;
                }
            }

            .btc-class {
                background: #FD8D1D;
            }

            .eth-class {
                background: #2869EC;
            }
        }
    }



    .security-center {
        .heading {
            padding: 12px 30px;
            font-size: 18px;
            display: flex;
            justify-content: left;
            align-items: center;
            border-bottom: 1px solid @border-color-base;

            /*no*/
            img {
                display: block;
                width: 20px;
                height: 20px;
                margin-top: 2px;
                margin-right: 10px;
            }

            .title {
                font-weight: 500;
                width: 790px;
                text-align: left;
                font-size: 18px;
            }
        }

        ul {
            padding-left: 60px;
            text-align: left;
            border-bottom: 1px solid @border-color-base;

            /*no*/
            li {
                min-height: 48px;
                display: flex;
                justify-content: left;
                border-bottom: 1px solid @border-color-base;
                /*no*/
                align-items: center;

                .label {
                    width: 260px;
                }

                .value {
                    width: 532px;
                    font-size: 14px;
                }

                .gree {
                    color: @green;
                }

                .red {
                    color: @red;
                }

                &:last-child {
                    border: none;
                }

                .headpic {
                    display: block;
                    width: 48px;
                    height: 48px;
                }
            }
        }
    }

    .security-center-2 {
        display: flex;
        justify-content: space-between;

        .security-center-half {
            width: 49%;
            margin-top: 25px;
            border-top: 1px solid #F2F4FB;

            ul {
                li {
                    font-size: 14px;
                    color: #666D7F;

                    .amount {
                        margin-left: 32px;
                    }

                    .id-name {
                        width: 160px;
                    }
                }
            }

            .add-acc {
                height: 28px;
                line-height: 26px;
                border: 1px solid #51B4F1;
                text-align: center;
                position: absolute;
                right: 32px;
                font-size: 14px;
                color: #51B4F1;
                border-radius: 4px;
                cursor: pointer;
                padding: 0 6px;
            }

            .heading {
                position: relative
            }
        }
    }

    .schedule-value {
        height: 110px;
    }

    .schedule {
        width: 664px;
        margin: 0 auto;
        display: flex;
        justify-content: left;
        margin-top: 30px;

        .step {
            position: relative;
            width: 160px;
            text-align: center;
            right: 50px;

            .number {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                background: @disabled-color;
                line-height: 30px;
                color: @white;
                margin: 0 auto;
            }

            p {
                font-size: 14px;
                margin-top: 10px;
            }
        }

        .step::after {
            content: '';
            display: block;
            height: 1px;
            /*no*/
            background: @disabled-color;
            position: absolute;
            top: 16px;
            left: 90px;
            width: 150px;
        }

        .step:last-child::after {
            content: '';
            display: none;
        }

        .step-active {
            .number {
                background: @primary-color;
            }

            p {
                color: @primary-color;
            }
        }

        .step-active::after {
            content: '';
            display: block;
            height: 1px;
            /*no*/
            background: @primary-color;
            position: absolute;
            top: 16px;
            left: 83px;
            width: 160px;
        }
    }

    .btn {
        width: 80px;
        height: 28px;
        line-height: 26px;
        text-align: center;
        border: 1px solid @primary-color;
        color: @primary-color;
        font-size: 14px;
        cursor: pointer;
        border-radius: 4px;
    }

    .lever-line {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &:first-child {
            margin-bottom: 16px;
        }
    }

    .lever-text {
        font-size: 14px;
        color: #EF383C;
        margin-top: 24px;
        margin-bottom: 8px;
    }

    .lever-pro {
        font-size: 14px;
        line-height: 24px;
    }

    .lever-btn {
        width: 100%;
        margin-top: 16px;
    }

    .haode {
        float: right;
        width: 80px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        color: white;
        font-size: 14px;
        background: #51B4F1;
        border-radius: 4px;
        margin-top: 32px;
        cursor: pointer;
    }

    .icon_success {
        width: 50px;
        height: 50px;
        display: block;
        margin: 0 auto;
    }

    .icon_success_pro {
        margin-top: 16px;
        text-align: center;
    }

    .step-box {
        .schedule-2 {
            width: 158px;
            margin: 0 auto;
            margin-bottom: 40px;

            .step-2 {
                display: flex;
                justify-content: left;
                align-items: center;
                margin-top: 40px;
                position: relative;

                .number {
                    width: 30px;
                    height: 30px;
                    flex-shrink: 0;
                    background: #CFD3DD;
                    line-height: 30px;
                    text-align: center;
                    color: white;
                    border-radius: 50%;
                    margin-right: 16px;
                    position: relative;
                    z-index: 1;
                }

                &::after {
                    content: '';
                    display: block;
                    width: 1px;
                    height: 60px;
                    background: #CFD3DD;
                    position: absolute;
                    left: 15px;
                    top: 27px;
                }

                &:last-child::after {
                    content: '';
                    display: none;
                }
            }

            .step-active {
                .number {
                    background: @primary-color;
                }

                p {
                    color: @primary-color;
                }
            }
        }
    }
}
</style>